var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M222.8,154.7c-.223,0-.4.127-.4.283v5.352c0,.156.181.283.4.283s.4-.127.4-.283v-5.352C223.206,154.83,223.025,154.7,222.8,154.7Zm0,0",
    transform: "translate(-213.42 -148.799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M104.8,154.7c-.223,0-.4.127-.4.283v5.352c0,.156.181.283.4.283s.4-.127.4-.283v-5.352C105.206,154.83,105.025,154.7,104.8,154.7Zm0,0",
    transform: "translate(-100.184 -148.799)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M1.143,4.452v7.673a1.8,1.8,0,0,0,.592,1.333A2.142,2.142,0,0,0,3.178,14h7.638a2.141,2.141,0,0,0,1.442-.541,1.8,1.8,0,0,0,.592-1.333V4.452a1.356,1.356,0,0,0,1.133-1.466A1.486,1.486,0,0,0,12.455,1.82H10.388V1.382A1.29,1.29,0,0,0,9.922.4,1.718,1.718,0,0,0,8.789,0H5.2A1.718,1.718,0,0,0,4.072.4a1.29,1.29,0,0,0-.466.982V1.82H1.539A1.486,1.486,0,0,0,.01,2.985,1.356,1.356,0,0,0,1.143,4.452ZM10.816,13.3H3.178a1.187,1.187,0,0,1-1.227-1.173V4.482H12.043v7.642A1.187,1.187,0,0,1,10.816,13.3ZM4.413,1.382A.632.632,0,0,1,4.642.9.843.843,0,0,1,5.2.7H8.789a.843.843,0,0,1,.562.2.632.632,0,0,1,.229.487V1.82H4.413ZM1.539,2.521H12.455a.684.684,0,0,1,.727.631.684.684,0,0,1-.727.631H1.539a.684.684,0,0,1-.727-.631A.684.684,0,0,1,1.539,2.521Zm0,0",
    transform: "translate(0.003 0.002)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d71b4",
    d: "M163.8,154.7c-.223,0-.4.127-.4.283v5.352c0,.156.181.283.4.283s.4-.127.4-.283v-5.352C164.206,154.83,164.025,154.7,163.8,154.7Zm0,0",
    transform: "translate(-156.802 -148.799)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.d33134573859bb0589b5219ae736d462.svg";
export { ForwardRef as ReactComponent };